var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-tool"},[(_vm.topAlert)?_c('el-alert',{staticClass:"iframe-tool__alert",attrs:{"title":_vm.topAlert.title,"type":_vm.topAlert.type,"center":""}}):_vm._e(),_c('iframe',{ref:"iframe",class:[
      'iframe-tool__iframe',
      { 'iframe-tool__iframe--loading': _vm.iframePlaceholder } ],attrs:{"frameborder":"0"}}),(_vm.iframePlaceholder)?_c('div',{class:[
      'iframe-tool__iframe-placeholder',
      _vm.iframePlaceholder.type,
      {
        'iframe-tool__iframe-placeholder--loading':
          _vm.iframePlaceholder.isLoading,
      } ]},[_vm._v("\n    "+_vm._s(_vm.iframePlaceholder.text)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }